(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6675],{

/***/ 38875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconMore = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 21,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M10.561 16c-.242 0-.477-.084-.665-.24l-6.233-5.043a.681.681 0 0 1-.094-.925.635.635 0 0 1 .894-.125l6.098 4.936 9.166-7.671a.635.635 0 0 1 .912.097.68.68 0 0 1-.096.938l-9.299 7.78a1.052 1.052 0 0 1-.683.253Zm-8.06-6.414a.646.646 0 0 1-.402-.142L.289 7.972a.682.682 0 0 1-.15-.968.635.635 0 0 1 .949-.078l1.815 1.468c.28.23.329.65.109.94a.653.653 0 0 1-.51.252Zm8.29-.369c-.243 0-.477-.084-.667-.24L3.875 3.943a.68.68 0 0 1-.095-.925.635.635 0 0 1 .895-.125l6.115 4.928L19.943.149a.637.637 0 0 1 .912.097.681.681 0 0 1-.095.94l-9.3 7.778c-.19.16-.425.25-.67.253ZM2.716 2.804a.659.659 0 0 1-.402-.142L.505 1.19a.68.68 0 0 1-.07-.903.636.636 0 0 1 .87-.142L3.12 1.612h-.001c.28.23.329.648.108.938a.658.658 0 0 1-.51.254Z",
  fill: "currentcolor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconMore);

/***/ }),

/***/ 14547:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favourites",
      function () {
        return __webpack_require__(45241);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var LazyImage = function(_param) {
    var src = _param.src, index = _param.index, width = _param.width, height = _param.height, alt = _param.alt, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "index",
        "width",
        "height",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), blur = ref[0], setBlur = ref[1];
    var getSmallImageSrc = function(src) {
        // Ensure src is a string before calling replace
        if (typeof src === "string") {
            return src.replace(/\b(1980|3840|640|960|360)\b/g, "64");
        }
        return null;
    };
    var isLayout = props.layout === "fill";
    // Filter out srcSet and sizes from props as Next.js Image doesn't support them directly
    // eslint-disable-next-line no-unused-vars
    var srcSet = props.srcSet, sizes = props.sizes, imageProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "srcSet",
        "sizes"
    ]);
    // Only render if src is a valid string
    if (src && typeof src === "string") {
        var blurDataURL = getSmallImageSrc(src);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            width: !isLayout && (width || 590),
            height: !isLayout && (height || 393),
            src: src,
            blurDataURL: blurDataURL,
            placeholder: blurDataURL ? "blur" : "empty",
            className: blur ? "img-blur" : "unblur",
            onLoadingComplete: function() {
                return setBlur(false);
            },
            alt: alt || "Property presentation image ".concat(index)
        }, imageProps));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (LazyImage);


/***/ }),

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42998);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34495);




var LineSeparator = function(param) {
    var _width = param.width, width = _width === void 0 ? false : _width, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: width ? {
            width: width
        } : {},
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_1__/* .withModifiers */ .i)("separator", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineSeparator);


/***/ }),

/***/ 24447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6644);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34495);
/* harmony import */ var _LazyImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20027);
/* eslint-disable react/prop-types */ 









var CloudflareVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    }
});
var Section = function(_param) {
    var children = _param.children, className = _param.className, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, bg = _param.bg, _video = _param.video, video = _video === void 0 ? false : _video, cloudflare = _param.cloudflare, _separator = _param.separator, separator = _separator === void 0 ? false : _separator, sectionRef = _param.sectionRef, _grayscale = _param.grayscale, grayscale = _grayscale === void 0 ? false : _grayscale, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "variant",
        "bg",
        "video",
        "cloudflare",
        "separator",
        "sectionRef",
        "grayscale"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: sectionRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(variant).concat([
            separator && "has-separator",
            bg && "with-bg"
        ]), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())), className)
    }, props), {
        children: [
            bg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: bg,
                priority: true,
                objectPosition: "center",
                objectFit: "cover",
                sizes: "(max-width: 360px) 960px, (max-width: 640px) 960px, (max-width: 1400px) 1400px, 1980px",
                alt: "section background image",
                layout: "fill"
            }),
            (cloudflare || video) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_7__/* .withModifiers */ .i)("section__video", [
                    grayscale && "grayscale"
                ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default())),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloudflareVideo, {
                        name: "Section presentation video",
                        autoplay: true,
                        loop: true,
                        muted: true,
                        src: cloudflare || video
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__overlay)
                    })
                ]
            }),
            separator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section__separator)
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Section);


/***/ }),

/***/ 27895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getS3Url; }
/* harmony export */ });
/* harmony import */ var lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);
/* harmony import */ var lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36378);
/* eslint-disable no-undef */ 

// URL cache to avoid redundant calculations
var urlCache = {};
// Detect mobile once and reuse
var isMobile = false;
var isMobileLandscape = false;
// Set up mobile detection only on client
if (true) {
    // Set this once at module level for initial render
    isMobile = window.innerWidth < 360;
    isMobileLandscape = window.innerWidth >= 360 && window.innerWidth < 640;
    // Update on resize with debouncing
    var resizeTimeout;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            var width = window.innerWidth;
            isMobile = width < 360;
            isMobileLandscape = width >= 360 && width < 640;
        }, 200);
    });
}
function getS3Url(url) {
    var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "public", video = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // Return early if no URL
    if (!url || !(0,lodash_es_isArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(url) && !(0,lodash_es_isString__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(url)) {
        return;
    }
    // For server-side rendering, use largest image
    var isServerSide = "object" === "undefined";
    // Use server defaults or client detection
    var effectiveIsMobile = isServerSide ? false : isMobile;
    var effectiveIsMobileLandscape = isServerSide ? false : isMobileLandscape;
    // Generate a cache key
    var cacheKey = "".concat(url, "-").concat(variant, "-").concat(video, "-").concat(effectiveIsMobile, "-").concat(effectiveIsMobileLandscape);
    // Return cached URL if available
    if (urlCache[cacheKey]) {
        return urlCache[cacheKey];
    }
    var result;
    // Determine which type of URL this is
    if (url.includes("images/") || url.includes("videos/")) {
        result = "https://assets.sxmsir.com/" + url.replace(/ /g, "%20");
    } else if (video) {
        result = "https://customer-".concat("mwbbzmyggbfuda1b", ".cloudflarestream.com/").concat(url, "/manifest/video.m3u8");
    } else {
        // Determine the cloudflare variant to use
        var cloudflareVariant;
        // Server-side: Prioritize provided variant if it exists, otherwise use largest
        if (isServerSide) {
            cloudflareVariant = variant && variant !== "public" && variant !== "" ? variant // Use provided variant if it exists and is not 'public' or empty
             : "1980" // Otherwise use largest variant for server-side
            ;
        } else {
            // Client-side: Use existing responsive logic
            cloudflareVariant = effectiveIsMobile ? 360 : effectiveIsMobileLandscape ? 640 : variant === "public" || variant === "" || !variant ? 960 : variant;
        }
        result = "https://imagedelivery.net/".concat("356b0XxwgMp5GfAe77K8NQ", "/").concat(url, "/").concat(cloudflareVariant);
    }
    // Cache the result
    urlCache[cacheKey] = result;
    return result;
}


/***/ }),

/***/ 50597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(117);
/* harmony import */ var _custom_EstateCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78032);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69950);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41197);
/* harmony import */ var _public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38875);
/* harmony import */ var _elements_LineSeparator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96143);
/* harmony import */ var _elements_Card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55877);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66261);












var Overview = function(param) {
    var properties = param.properties, _type = param.type, type = _type === void 0 ? "real-estate" : _type, shadowRef = param.shadowRef, scrollRef = param.scrollRef, _totalCards = param.totalCards, totalCards = _totalCards === void 0 ? 999 : _totalCards, generalTranslation = param.generalTranslation, _buttonLabel = param.buttonLabel, buttonLabel = _buttonLabel === void 0 ? "View more real estate" : _buttonLabel, _unlimited = param.unlimited, unlimited = _unlimited === void 0 ? false : _unlimited, title = param.title;
    var scroll = react_scroll__WEBPACK_IMPORTED_MODULE_9__["default"].animateScroll;
    var handleScroll = function() {
        var ref;
        return scrollRef && scroll.scrollTo(((ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().top) - document.body.getBoundingClientRect().top - 150);
    };
    if (properties) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "white",
                "pt0",
                "center"
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: shadowRef,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().overlay)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    variant: [
                        "-xxl"
                    ],
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().grid),
                            variant: [
                                "grid-".concat(totalCards)
                            ],
                            children: properties.map(function(item, index) {
                                if (index < totalCards || unlimited) {
                                    if (type === "real-estate") {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_EstateCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                            translations: generalTranslation
                                        }, item), index);
                                    } else {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Card__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                            translations: generalTranslation
                                        }, item), index);
                                    }
                                }
                            })
                        }),
                        buttonLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LineSeparator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            variant: [
                                "vertical"
                            ]
                        }),
                        buttonLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_5__["default"], {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().button),
                            appendIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                            onClick: handleScroll,
                            variant: [
                                "color-primary"
                            ],
                            children: buttonLabel
                        })
                    ]
                })
            ]
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (Overview);


/***/ }),

/***/ 45241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_Page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51904);
/* harmony import */ var _components_elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _components_elements_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24447);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(52652);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40670);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92375);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_pages_real_estate_Overview__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50597);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _providers_favouritesProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83155);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(79697);
/* harmony import */ var _components_elements_LineSeparator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96143);
/* harmony import */ var _components_elements_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41197);
/* harmony import */ var _providers_authProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89149);
/* harmony import */ var _components_elements_Card__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55877);
/* harmony import */ var _components_elements_Grid__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(117);
/* harmony import */ var _components_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56375);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64636);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(98077);























var Favourites = function(param) {
    var generalTranslation = param.generalTranslation, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, pageTranslations = param.pageTranslations;
    var ref, ref1, ref2, ref3, ref4;
    var favourites = (0,_providers_favouritesProvider__WEBPACK_IMPORTED_MODULE_9__/* .useFavouritesContext */ .H2)().favourites;
    var loggedIn = (0,_providers_authProvider__WEBPACK_IMPORTED_MODULE_12__/* .useAuthContext */ .Eu)().loggedIn;
    var ref5 = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_4__/* .useResponsive */ .F)(), isTablet = ref5.isTablet, isSmallMobile = ref5.isSmallMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(""), success = ref6[0], setSuccess = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)({}), properties = ref7[0], setProperties = ref7[1];
    var hasProperties = !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(properties === null || properties === void 0 ? void 0 : (ref = properties.realEstate) === null || ref === void 0 ? void 0 : ref[router.locale]) || !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(properties === null || properties === void 0 ? void 0 : (ref1 = properties.vacationRentals) === null || ref1 === void 0 ? void 0 : ref1[router.locale]);
    var formInitialValues = {
        name: "",
        email: ""
    };
    var FormValidation = yup__WEBPACK_IMPORTED_MODULE_17__/* .object */ .Ry().shape({
        name: yup__WEBPACK_IMPORTED_MODULE_17__/* .string */ .Z_().max(25).matches(RegExp("^'?\\p{L}+(?:[' ]\\p{L}+)*'?$", "u"), pageTranslations.form.error.validName[router.locale]).required(pageTranslations.form.error.requiredFirstName[router.locale]),
        email: yup__WEBPACK_IMPORTED_MODULE_17__/* .string */ .Z_().max(254).matches(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, pageTranslations.form.error.validEmail[router.locale]).email(pageTranslations.form.error.validEmail[router.locale]).required(pageTranslations.form.error.requiredEmail[router.locale])
    });
    var handleSubmit = function(values, param) {
        var setSubmitting = param.setSubmitting, resetForm = param.resetForm;
        var ref, ref1, ref2, ref3;
        setSubmitting(true);
        var realEstateLinks = (properties === null || properties === void 0 ? void 0 : (ref = properties.realEstate) === null || ref === void 0 ? void 0 : (ref1 = ref.en) === null || ref1 === void 0 ? void 0 : ref1.map(function(realEstate) {
            return(// eslint-disable-next-line no-undef
            "".concat("https://sxmsir.com", "/real-estate/").concat(realEstate.slug));
        })) || [];
        var vacationRentalsLinks = (properties === null || properties === void 0 ? void 0 : (ref2 = properties.vacationRentals) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.en) === null || ref3 === void 0 ? void 0 : ref3.map(function(vacationRental) {
            var ref;
            // eslint-disable-next-line no-undef
            return "".concat("https://sxmsir.com", "/vacation-rentals/").concat(vacationRental.nickname, "-").concat(vacationRental.bedrooms, "-bedroom-").concat((((ref = vacationRental.propertyType) === null || ref === void 0 ? void 0 : ref.en) || "villa").toLowerCase());
        })) || [];
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .Z.post("favourites/send-email", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, values), {
            content: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(realEstateLinks).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(vacationRentalsLinks))
        })).then(function() {
            setSuccess(true);
            resetForm();
        }).catch(function(err) {
            setSuccess(false);
            console.error(err);
        }).finally(function() {
            setSubmitting(false);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function() {
        if (!(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(favourites)) {
            _components_configs_axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("favourites/details", {
                params: {
                    ids: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(favourites)
                }
            }).then(function(res) {
                var data = res.data;
                // Handle both array format and legacy object format
                if (Array.isArray(data)) {
                    // API returns flat array - transform to expected structure
                    var realEstate = data.filter(function(p) {
                        return p && typeof p === "object" && p.type === "real-estate";
                    });
                    var vacationRentals = data.filter(function(p) {
                        return p && typeof p === "object" && p.type !== "real-estate";
                    });
                    setProperties({
                        realEstate: realEstate.length > 0 ? {
                            en: realEstate,
                            fr: realEstate,
                            es: realEstate,
                            nl: realEstate
                        } : null,
                        vacationRentals: vacationRentals.length > 0 ? {
                            en: vacationRentals,
                            fr: vacationRentals,
                            es: vacationRentals,
                            nl: vacationRentals
                        } : null
                    });
                } else {
                    // Legacy format - use as-is
                    setProperties(data);
                }
            }).catch(function(err) {
                console.error("[FavouritesPage] API error:", err);
            });
        } else {
            setProperties({});
        }
    }, [
        favourites
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_templates_Page__WEBPACK_IMPORTED_MODULE_1__["default"], {
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        footer: false,
        meta: {
            title: pageTranslations.seo.title.en,
            description: pageTranslations.seo.description.en
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Section__WEBPACK_IMPORTED_MODULE_3__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().intro),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().intro__title),
                            children: pageTranslations.page.title[router.locale]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_LineSeparator__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().intro__subtitle),
                            children: !hasProperties ? pageTranslations.page.emptyProperties[router.locale] : pageTranslations.page.description[router.locale]
                        }),
                        !hasProperties && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_11__["default"], {
                            variant: [
                                "m-t-3xl"
                            ],
                            href: "/vacation-rentals",
                            children: pageTranslations.page.browseProperties[router.locale]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_real_estate_Overview__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                totalCards: isSmallMobile ? 1 : isTablet ? 2 : 3,
                unlimited: true,
                properties: properties === null || properties === void 0 ? void 0 : (ref2 = properties.realEstate) === null || ref2 === void 0 ? void 0 : ref2[router.locale],
                generalTranslation: generalTranslation,
                buttonLabel: false
            }),
            !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(properties === null || properties === void 0 ? void 0 : (ref3 = properties.vacationRentals) === null || ref3 === void 0 ? void 0 : ref3[router.locale]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Section__WEBPACK_IMPORTED_MODULE_3__["default"], {
                variant: [
                    "center",
                    "primary"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().intro__title),
                            children: pageTranslations.page.vacationRentals[router.locale]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            variant: [
                                "grid-".concat(isSmallMobile ? 1 : 2)
                            ],
                            children: properties === null || properties === void 0 ? void 0 : (ref4 = properties.vacationRentals) === null || ref4 === void 0 ? void 0 : ref4[router.locale].map(function(property, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                    translations: headerTranslation.card
                                }, property), property.resource_id || property.id || index);
                            })
                        })
                    ]
                })
            }),
            hasProperties && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Section__WEBPACK_IMPORTED_MODULE_3__["default"], {
                variant: [
                    "center",
                    "white"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    variant: [
                        "-xs4"
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().subtitle),
                            dangerouslySetInnerHTML: {
                                __html: pageTranslations.form.title[router.locale]
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().description),
                            children: pageTranslations.form.description[router.locale]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_16__/* .Formik */ .J9, {
                            validationSchema: FormValidation,
                            initialValues: formInitialValues,
                            onSubmit: handleSubmit,
                            children: function(param) {
                                var errors = param.errors, touched = param.touched, values = param.values;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_16__/* .Form */ .l0, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Grid__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                            variant: [
                                                "grid-2",
                                                "spacing-xs"
                                            ],
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    required: true,
                                                    name: "name",
                                                    isActive: values.name,
                                                    maxLength: 254,
                                                    placeholder: pageTranslations.form.fields.name[router.locale],
                                                    variant: [
                                                        "gray",
                                                        "underline",
                                                        "full-width"
                                                    ],
                                                    error: errors.name && touched.name,
                                                    valid: values.name && !errors.name && touched.name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_form_CustomField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    required: true,
                                                    name: "email",
                                                    type: "email",
                                                    isActive: values.email,
                                                    maxLength: 254,
                                                    placeholder: pageTranslations.form.fields.email[router.locale],
                                                    variant: [
                                                        "gray",
                                                        "underline",
                                                        "full-width"
                                                    ],
                                                    error: errors.email && touched.email,
                                                    valid: values.email && !errors.email && touched.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_11__["default"], {
                                            disabled: errors.email || errors.name || values.name === "" || values.email === "",
                                            variant: [
                                                "primary-blue",
                                                "full-width",
                                                "m-t-xl"
                                            ],
                                            children: pageTranslations.form.fields.submit[router.locale]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().confirmation),
                                            children: success === "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : success ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().success),
                                                children: pageTranslations.form.success[router.locale]
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().error),
                                                children: pageTranslations.form.fail[router.locale]
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            }),
            !loggedIn && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(favourites) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Section__WEBPACK_IMPORTED_MODULE_3__["default"], {
                variant: [
                    "gray",
                    "center"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default().subtitle),
                            dangerouslySetInnerHTML: {
                                __html: pageTranslations.page.save[router.locale]
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Button__WEBPACK_IMPORTED_MODULE_11__["default"], {
                            href: "/login",
                            variant: [
                                "primary-blue"
                            ],
                            children: pageTranslations.page.login[router.locale]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Favourites);


/***/ }),

/***/ 42998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__LP5R2","separator--vertical":"styles_separator--vertical__XAMVo","separator--center":"styles_separator--center__qDfXg","separator--full-width":"styles_separator--full-width__WOn53"};

/***/ }),

/***/ 6644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__yHGzn","section__image":"styles_section__image__3wu_0","section__separator":"styles_section__separator__jTwxZ","section__overlay":"styles_section__overlay__S4fzZ","section__video":"styles_section__video__aGMVE","section__video--grayscale":"styles_section__video--grayscale__cSkkv","section--separator-large":"styles_section--separator-large__e2xv7","section--has-separator":"styles_section--has-separator__9vXz9","section--separator-top":"styles_section--separator-top__EcwNQ","section--gray":"styles_section--gray__GL0Sw","section--white":"styles_section--white__NJa_K","section--contained":"styles_section--contained__Laf5M","section--center":"styles_section--center__LmG2q","section--primary":"styles_section--primary__GuN0k","section--darker":"styles_section--darker__uJmer","section--bg-body":"styles_section--bg-body__g_dZD","section--o-hidden":"styles_section--o-hidden__xJTM8","section--with-bg":"styles_section--with-bg__fgmbo","section--pt0":"styles_section--pt0__IoFne","section--full-height":"styles_section--full-height__xFIuY","section--bottom":"styles_section--bottom__hRh3f","section--p0":"styles_section--p0__CiUN0","section--pb0":"styles_section--pb0__OvCBe","section--p-xs":"styles_section--p-xs__AOSqe","section--p-xl":"styles_section--p-xl__9nhJz","section--z-7":"styles_section--z-7__RDdr0"};

/***/ }),

/***/ 69950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__BdQPF","button":"styles_button__XgHPz","overlay":"styles_overlay__AGHfS"};

/***/ }),

/***/ 52652:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__U7GVo","intro__title":"styles_intro__title__1DU58","intro__subtitle":"styles_intro__subtitle__asDlE","confirmation":"styles_confirmation__2vlHL","subtitle":"styles_subtitle__FONwn","description":"styles_description__NCSmO","success":"styles_success__NKlsY","error":"styles_error__6dPgT"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,2756,5675,7549,6820,8433,5798,3808,9584,8094,3817,5585,5444,2133,9774,945,2888,179], function() { return __webpack_exec__(14547); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);